<template>
    <div>
  <top-navbar></top-navbar>
  <div class=" mb-5 background_color" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicles  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Inventory  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/idealerassignvehicle/index"> Manage Allocate Vehicles</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Accept Stock  </h6>

      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >

  </div>

        </div>
    

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

        <button  @click="modelsCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">  Accept Physical Stock</button>
        <button  @click="retransfer()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">  Stock Transfer</button>
     

        <div>
  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1">No</button>
    </template>

  
  </b-modal>

 
</div>
  
      </div>
    </div>
    <div class="card bdr-rad2 mt-1 shadow p-2">
    <div class="card-body " >
<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>


       <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->
   
  <div class="table-responsive">
   

    <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead style="border-bottom: 2px solid black; ">
                            <tr>
                            <th></th>
                            <th>#</th>
                            <th>Model</th>
                            <th>Engine</th>
                        
                            <th >Chassis No.</th>
                            <th >	Color</th>
                            <th >Dealer	</th>
                            <th >Transfer Date</th>
                      
                            <th >Remarks</th>
                            <th >Created Date	</th>
                            <th >Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr  v-for="(all_data, index) in all_datas" :key="all_data.id">
                            <td>
                              <div class="ms-4">
                                <input class="form-check-input" type="checkbox" v-model="all_data.check">
                                <input v-model="all_data.id" type="hidden" />
                              </div>   
                            </td>
                            <td>{{ index+1 }}</td>
                            <td> {{ all_data.modelname }}</td>
                            <td >{{all_data.engineno}}</td>
                            <td >{{ all_data.chassisno }}</td>
                            <td >{{ all_data.colorcode }}</td>
                            <td >{{ all_data.C_name }}</td>
                            <td >{{ all_data.transfer_date }}</td>
                            <td >{{ all_data.remarks }}</td>
                            <td >{{ all_data.created_date }}</td>
                        
                        
                            <td>{{ all_data.status }}</td>



                            </tr>
                           
                           
                         
                          </tbody>

                        </table>



   

  </div>

  </div>
 
  
  

  <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button @click="accept()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">Accept Selected</button>
    </div>
    </div>


  
  </div>
    </div>

    <br><br>
  </div>
  </div>

  <content-footer></content-footer>
</div>
  
  
  </template>
  
  <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'
  
  
  
  
  export default {
    components :{
       
        TopNavbar,
        ContentFooter,
        
    },
  
      mounted(){
    this.loadMiinventory()
      },
     
      computed: {
        
  
  
  
      },
  
      data(){
      return{
        isModalOpen: false,
        all_datas:[],
      
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        quatations1: {},
        totalRows: 1,
        currentPage: 1,
        perPage:20,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        fields: [
            { key: 'check', label: '', sortable: true, sortDirection: 'desc' },
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
        
          { key: 'modelname', label: 'Model', sortable: true  },
          { key: 'engineno', label: 'Engine', sortable: true  },
          { key: 'chassisno', label: 'Chassis No.', sortable: true  },
          { key: 'colorcode', label: 'Color', sortable: true  },
          { key: 'C_name', label: 'Dealer', sortable: true  },
          { key: 'transfer_date', label: 'Transfer Date', sortable: true ,  },
        
       
          { key: 'remarks', label: 'Remarks', sortable: true ,  },
          { key: 'created_date', label: 'Created Date', sortable: true ,  },
          { key: 'status', label: 'Status', sortable: true ,  },
               
          
        //   { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        isLoading: true, 
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
       
       
      };
      },
  
      
  
  
     methods:{ 



    





  
      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async accept() {
    
    try {
      const { data} = await  axios.post('/idealerassignvehicle/acceptdone',{all_datas:this.all_datas},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       if(data.status==200){
        this.loadMiinventory()
        }
      
      
    } catch (error) {
      console.log(error.response);
    }
  },
  async moreinfo(id) {
  
    this.$router.push('/mmodels/view?id='+id);
   
  },
  async modelsCreate() {
  
    this.$router.push('/mmodels/create');
   
  },
  async retransfer() {
  
    this.$router.push('/idealerassignvehicle/retransfer');
   
  },
  async Createso(id){
        this.$router.push('/ssalesorder/create?id='+id);
      },
  async Update(id){
        this.$router.push('/quotation/update?id='+id);
      },

      async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
  
      serchCustom(id) {

    this.filterOn = id;
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
      async loadMiinventory() {
       
    
      try {
        const { data} = await  axios.get('/idealerassignvehicle/accept',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_datas = data.all_data;
       
          this.isLoading = false; 
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/squatation/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  
   
  
  
  
  
  
  }
  
  
  
  
  };
  
  </script>
  
  <style >


  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
    border-bottom: 1px solid #E9E9E3;
    border-top: 1px solid #E9E9E3;
  }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;
      
      }
      .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;
          
      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }
   
  .modal-footer{
    text-align: right !important;
    display: block;
  }
  
  </style>